import { useTranslation } from 'react-i18next'
import UploadImage from 'components/reusables/uploadImage'
import { Wrapper, Subtitle } from './styled'

interface IProps {
  image: File | string | null
  setImage: (value: File | null) => void
}

const BackgroundImage = ({ image, setImage }: IProps) => {
  const { t } = useTranslation()
  const translatePrefix = 'administration.certificate.new.backgroundImage'

  return (
    <Wrapper>
      <Subtitle>{t(`${translatePrefix}.title`)}</Subtitle>
      <UploadImage image={image} setImage={setImage} />
    </Wrapper>
  )
}

export default BackgroundImage
